/**
 * Formateringsfunksjoner for data
 */

/**
 * Formater pace (min/km)
 * @param {number} seconds - Totalt antall sekunder
 * @param {number} km - Totalt antall kilometer
 * @returns {string} Formatert pace (f.eks. "5:30")
 */
export const formatPace = (seconds, km) => {
  if (!km || km === 0) return "0:00";
  
  const paceSeconds = seconds / km;
  const mins = Math.floor(paceSeconds / 60);
  const secs = Math.floor(paceSeconds % 60);
  
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Formater hastighet (km/t)
 * @param {number} seconds - Totalt antall sekunder
 * @param {number} km - Totalt antall kilometer
 * @returns {string} Formatert hastighet (f.eks. "12.5")
 */
export const formatKmH = (seconds, km) => {
  if (!seconds || seconds === 0) return "0.0";
  
  const speed = (km / (seconds / 3600));
  return speed.toFixed(1);
};

/**
 * Formater varighet
 * @param {number} seconds - Antall sekunder
 * @returns {string} Formatert varighet (f.eks. "1t 23m" eller "45m 30s")
 */
export const formatDuration = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  
  return h > 0 ? `${h}t ${m}m` : `${m}m ${s}s`;
};

/**
 * Generer tilfeldig konkurransekode
 * @returns {string} 10-tegns kode
 */
export const generateCode = () => {
  return Math.random().toString(36).substring(2, 12).toLowerCase();
};

/**
 * Formater dato
 * @param {string|Date} date - Dato
 * @param {string} locale - Språkkode (default: 'no-NO')
 * @returns {object} Objekt med dag og måned
 */
export const formatDate = (date, locale = 'no-NO') => {
  const d = new Date(date);
  return {
    day: d.toLocaleDateString(locale, { day: '2-digit' }),
    month: d.toLocaleDateString(locale, { month: 'short' }).replace('.', '')
  };
};
